
import Component, { ComponentMethods } from "@/module/component/component"

import Package from "@/../package.json"
import Queue from "@/module/queue/queue"
import Request from "@/module/request/request"
import Cache from "@/module/cache/cache"
import Utils from "@/module/utils/utils"
import Version from "@/module/version/version"
import Message from "@/module/interactive/message"

import elemIcon from "@/components/elem-icon.vue"
import compMenu from "@/components/comp-menu.vue"

import md5 from "js-md5"
import Modal from "@/module/interactive/modal"
import Path from "@/module/config/path"

class LoginPage extends ComponentMethods implements ComponentEntity {
    private input_focus: obj = {}

    private input_step: string = "username"

    private internal = {
        steps: [
            {
                name: "username",
                ref: "username_input",
                submit: function () {
                    if (!this.username) {
                        return (this.username_error = "用户名不能为空")
                    }
                    this.getAccountInfo()
                },
            },
            {
                name: "password",
                ref: "password_input",
                submit: function () {
                    if (!this.password) {
                        return (this.password_error = "密码不能为空")
                    }
                    this.onSubmit()
                },
            },
            {
                name: "code",
                ref: "code_input",
                submit: function () {
                    if (!this.code) {
                        return (this.code_error = "验证码不能为空")
                    }
                    this.onSubmit()
                },
            },
            {
                name: "forgot_username",
                ref: "forgot_username_input",
                prompt: "请输入需要找回密码的用户名",
                submit: function () {
                    this.onSubmitForgotUsername()
                },
            },
            {
                name: "forgot_email",
                ref: "forgot_email_input",
                prompt: function () {
                    return "请输入电子邮箱：" + this.userinfo.email
                },
                submit: function () {
                    this.onSubmitForgotEmail()
                },
            },
            {
                name: "forgot_code",
                ref: "forgot_code_input",
                prompt: "请输入电子邮箱验证码",
                submit: function () {
                    this.onSubmitForgotCode()
                },
            },
            {
                name: "forgot_password",
                ref: "forgot_password_input",
                prompt: "请输入新密码",
                submit: function () {
                    this.onSubmitForgotPassword()
                },
            },
            {
                name: "forgot_confirm_password",
                ref: "forgot_confirm_password_input",
                prompt: "请再次输入新密码",
                submit: function () {
                    this.onSubmitForgotConfirmPassword()
                },
            },
        ],
    }

    private callback: (() => void)[] = []

    private codeInfo: obj = null

    private info: obj = {
        icon: "logo.png",
        name: "晟浩科技",
    }

    private loading: boolean = false

    private username: string = null
    private username_error: string = null

    private password: string = null
    private password_error: string = null
    private isPasswordType: boolean = true

    private code: string = null
    private code_error: string = null

    private forgot_username: string = null
    private forgot_username_error: string = null

    private forgot_email: string = null
    private forgot_email_error: string = null

    private forgot_code: string = null
    private forgot_code_error: string = null
    private forgot_code_time: string = "59"
    private forgot_code_id: string

    private forgot_password: string = null
    private forgot_password_error: string = null

    private forgot_confirm_password: string = null
    private forgot_confirm_password_error: string = null

    private auto_login: boolean = false

    private userinfo: obj = {
        avatar: "logo.png",
        username: "admin",
    }

    private setting_menu = null

    private prompt: string = null

    data() {
        return {
            display: false,
            show: false,
            version: Package.version,
        }
    }

    watch = {
        username() {
            if (this.username_error) {
                this.username_error = null
            }
        },

        input_step(value: string) {
            Utils.find<obj>(
                this.internal.steps,
                c => c.name == value,
                v => {
                    const data = v.data

                    this[value] = null
                    this.prompt = typeof data.prompt === "function" ? data.prompt.call(this) : data.prompt

                    // 延时 300ms，等待动画结束
                    Utils.wait(() => {
                        // 触发焦点事件
                        this.$refs[data.ref].focus()
                    }, 500)
                }
            )
        },
    }

    components = {
        elemIcon,
        compMenu,
    }

    created() {
        const _this = this

        window["Login"] = class {
            public static do(callback?: () => void): void {
                Cache.remove("admin_token")

                if (callback) {
                    _this.callback.push(callback)
                }

                if (!_this.display) {
                    if (Cache.containsKey("auto_login")) {
                        // 自动登录
                        _this.autoLogin()
                    } else {
                        // 显示登录页面
                        _this.onDisplay()
                    }
                }
            }
        }

        const version = {
            title: "版本管理",
            prompt: "版本展示用于判断管理端与主程序之间是否兼容。",
            sub: [
                {
                    id: "admin_version",
                    icon: "admin",
                    name: "管理端版本",
                    value: Package.version,
                },
            ],
        }

        this.setting_menu = [
            version,
            {
                title: "调试",
                prompt: "用于调试程序异常",
                sub: [
                    {
                        id: "debug_mode",
                        icon: "compare",
                        name: "调试模式",
                    },
                ],
            },
        ]

        Version.get().then(res => {
            version.sub.push(
                {
                    id: "framework_version",
                    icon: "framework",
                    name: "主程序版本",
                    value: res.framework,
                },
                {
                    id: "compare_version",
                    icon: "compare",
                    name: "兼容主程序版本",
                    value: ">=" + res.min_framework,
                }
            )

            var match = Utils.versionToNumber(res.framework) >= Utils.versionToNumber(res.min_framework)

            if (!match) {
                Modal.info(
                    `
                    <p>当前框架版本低于管理端最低要求版本，可能导致部分服务不可用，请联系技术支持进行框架版本升级。</p>
                    <p style="margin-top: 10px">最低要求版本：${res.min_framework}</p>
                    <p>当前版本：${res.framework}</p>
                `,
                    {
                        title: "版本提示",
                    }
                )
            }
        })
    }

    mounted() {
        Cache.onGet<obj>("setting_info", res => {
            // LOGO
            res.icon && (this.info.icon = res.icon.url)
            this.info.name = res.name || "晟浩科技"
        })
    }

    public onBackStep() {
        if (this.input_step === "forgot_username") {
            this.input_step = "username"
        } else {
            Utils.find<obj>(
                this.internal.steps,
                c => c.name === this.input_step,
                v => {
                    this.input_step = this.internal.steps[v.i - 1].name
                }
            )
        }
    }

    public autoLogin() {
        const info = Cache.get<obj>("auto_login")

        Request.post<obj>(
            "WEB://AdminAccount/Login",
            {
                username: info.username,
                password: info.password,
            },
            {
                hideLoading: true,
                hideMessage: true,
                onFail: () => {
                    // 显示登录页面
                    this.onDisplay()
                },
            }
        ).then(res => {
            Cache.set(
                {
                    admin_token: res.admin_token,
                    admin_id: res.admin_id,
                    userinfo: res.userinfo,
                },
                { storage: "cookie", expires: 2 * 60 * 60 * 1000 }
            )

            // 刷新页面
            Utils.each(this.callback, v => {
                v()
                // 触发事件后移除
                return "delete"
            })
        })
    }

    /** 获取验证码数据 */
    public getValidateCode() {
        Queue.single("Login-GetValidateCode", next => {
            this.codeInfo = null

            Request.get<obj>("WEB://ValidateCode/GetCode", {
                nature: "ADMIN_LOGIN"
            }, {
                hideLoading: true,
                onComplete: () => {
                    next()
                },
            }).then(res => {
                this.codeInfo = res
            })
        })
    }

    public async onSubmit() {
        // 显示加载动画
        this.loading = true

        setTimeout(() => {
            Request.post<obj>(
                "WEB://AdminAccount/Login",
                {
                    username: this.username,
                    password: md5(this.password),

                    ...(this.codeInfo
                        ? {
                              codeId: this.codeInfo.id,
                              code: this.code,
                          }
                        : {}),
                },
                {
                    hideLoading: true,
                    onFail: err => {
                        if (err.status === 400) {
                            switch (err.code) {
                                // 要求输入验证码
                                case "ENTER_VERIFICATION_CODE":
                                    this.input_step = "code"
                                    // 获取验证码
                                    this.getValidateCode()
                                    break
                                case "CODE_ERROR":
                                    this.code_error = "验证码错误"
                                    // 清空输入框
                                    this.code = null
                                    // 重新获取验证码
                                    this.getValidateCode()
                                    // 获取焦点
                                    this.$refs.code_input.focus()
                                    break
                                case "PASSWORD_NULL":
                                    this.password_error = "当前账号未设置密码"
                                    // 清空输入框
                                    this.password = null
                                    break
                                case "PASSWORD_WRONG":
                                    this.password_error = "密码错误"
                                    // 清空输入框
                                    this.password = null
                                    // 获取焦点
                                    this.$refs.password_input.focus()
                                    break
                            }

                            return false
                        }
                    },
                    onComplete: () => {
                        // 关闭加载动画
                        this.loading = false
                    },
                }
            ).then(res => {
                Cache.set(
                    {
                        admin_token: res.admin_token,
                        admin_id: res.admin_id,
                        userinfo: res.userinfo,
                    },
                    { storage: "cookie", expires: 2 * 60 * 60 * 1000 }
                )

                if (this.auto_login) {
                    Cache.set(
                        {
                            auto_login: {
                                username: this.username,
                                password: md5(this.password),
                            },
                        },
                        { storage: "cookie", expires: 7 * 24 * 60 * 60 * 1000 }
                    )
                }

                // 刷新页面
                Utils.each(this.callback, v => {
                    v()
                    // 触发事件后移除
                    return "delete"
                })

                this.onChangeDisplay(false)
            })
        }, 2000)
    }

    onStartForgotCodeTime() {
        var start: number = 59

        clearInterval(this.forgot_code_time_interval)

        this.forgot_code_time_interval = setInterval(() => {
            this.forgot_code_time = Utils.paddingZero(--start)

            if (start <= 0) {
                clearInterval(this.forgot_code_time_interval)
            }
        }, 1000)
    }

    onChangeFocusInput(name: string, focus: boolean): void {
        this.input_focus[name] = focus
    }

    getAccountInfo(): void {
        this.loading = true

        Utils.wait(() => {
            Request.get(
                "WEB://AdminAccount/GetAccountInfo",
                { username: this.username },
                {
                    onFail: err => {
                        if (err.status === 400 && err.code === "NOT_USERNAME") {
                            this.username_error = "账号不存在"
                            return false
                        }
                    },
                    onComplete: () => {
                        this.loading = false
                    },
                }
            ).then(res => {
                this.userinfo = res
                this.input_step = "password"
            })
        }, 2000)
    }

    onNextStep() {
        Utils.find<obj>(
            this.internal.steps,
            c => c.name == this.input_step,
            v => {
                const data = v.data
                // 触发提交事件
                data.submit.call(this)
            }
        )
    }

    onChangePasswordType() {
        this.isPasswordType = !this.isPasswordType
    }

    onSubmitInput(evt: obj) {
        const e: HTMLInputElement = evt.target
        // 触发失焦事件
        e.blur()
        // 下一步
        this.onNextStep()
    }

    getStepTitle() {
        switch (this.input_step) {
            case "forgot_username":
            case "forgot_password":
            case "username":
                return "继续"
            case "password":
                return "登录"
            case "forgot_code":
            case "code":
                return "验证"
            case "forgot_email":
                return "获取验证码"
            case "forgot_confirm_password":
                return "提交"
        }
    }

    isForgot() {
        const step = this.input_step
        return step.indexOf("forgot") > -1
    }

    onDisplay() {
        this.input_step = "username"
        this.onChangeDisplay(true)
    }

    onChangeDisplay(display: boolean) {
        if (display) {
            this.show = true

            Utils.wait(() => {
                this.display = true
            })
        } else {
            this.display = false

            Utils.wait(() => {
                this.show = false
            }, 500)
        }
    }

    /**
     * 提交找回密码用户名
     */
    onSubmitForgotUsername() {
        if (!this.forgot_username) {
            return (this.forgot_username_error = "用户名不能为空")
        }

        this.loading = true

        Utils.wait(() => {
            Request.get(
                "WEB://AdminAccount/GetForgotAccountInfo",
                { username: this.forgot_username },
                {
                    onFail: err => {
                        if (err.status === 400) {
                            switch (err.code) {
                                case "NOT_USERNAME":
                                    this.forgot_username_error = "账号不存在"
                                    return false
                                case "NO_EMAIL":
                                    this.forgot_username_error = "未绑定电子邮箱"
                                    Message.error("当前用户未绑定电子邮箱，请联系技术支持！")
                                    return false
                            }
                        }
                    },
                    onComplete: () => {
                        this.loading = false
                    },
                }
            ).then(res => {
                this.userinfo = res
                this.input_step = "forgot_email"
            })
        }, 2000)
    }

    onSubmitForgotEmail() {
        if (!this.forgot_email) {
            return (this.forgot_email_error = "电子邮箱不能为空")
        }

        Request.post<string>("WEB://AdminAccount/SendEmailCode", {
            username: this.forgot_username,
            email: this.forgot_email,
        }).then(res => {
            this.forgot_code_id = res
            this.input_step = "forgot_code"
            this.onStartForgotCodeTime()
        })
    }

    onSubmitForgotPassword() {
        if (!new RegExp("(?=.*[0-9])(?=.*[a-zA-Z]).{6,}").test(this.forgot_password)) {
            return (this.forgot_password_error = "密码中必须包含字母和数字且至少6个字符")
        }

        this.input_step = "forgot_confirm_password"
    }

    onSubmitForgotConfirmPassword() {
        if (this.forgot_password !== this.forgot_confirm_password) {
            return (this.forgot_confirm_password_error = "两次密码不相同，请检查后重试")
        }

        Request.post("WEB://AdminAccount/ResetPassword", {
            username: this.forgot_username,
            email: this.forgot_email,
            codeId: this.forgot_code_id,
            code: this.forgot_code,
            password: md5(this.forgot_password),
        }).then(() => {
            Message.success("重置密码成功")
            this.input_step = "username"
        })
    }

    onSubmitForgotCode() {
        if (!this.forgot_code) {
            return (this.forgot_code_error = "验证码不能为空")
        }

        Request.post<string>("WEB://AdminAccount/VerifyEmailCode", {
            username: this.forgot_username,
            email: this.forgot_email,
            codeId: this.forgot_code_id,
            code: this.forgot_code,
        }).then(() => {
            this.input_step = "forgot_password"
        })
    }

    onSendForgotCode() {
        Request.post<string>("WEB://AdminAccount/SendEmailCode", {
            username: this.forgot_username,
            email: this.forgot_email,
        }).then(res => {
            this.forgot_code_id = res
            this.onStartForgotCodeTime()
        })
    }

    onSelectSettingMenu(evt: ElemEvent<string>) {
        if (evt.value === "debug_mode") {
            var getQueryString = function (name) {
                let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
                let r = window.location.search.substr(1).match(reg)
                if (r != null) {
                    return unescape(r[2])
                }
                return null
            }

            Path.DOMAIN = getQueryString("url")

            console.log(this.getParam<string>("url"))

            console.log(Path.DOMAIN)

            return
        }

        Version.get().then(res => {
            switch (evt.value) {
                case "admin_version":
                    Message.info("管理端程序版本为：" + res.admin)
                    break
                case "framework_version":
                    Message.info("主程序版本为：" + res.framework)
                    break
                case "compare_version":
                    // 两个比较版本号
                    var match = Utils.versionToNumber(res.framework) >= Utils.versionToNumber(res.min_framework)

                    if (match) {
                        Message.success("当前主程序符合最低版本要求")
                    } else {
                        Message.error("当前主程序不符合最低版本要求，请联系技术支持！")
                    }
                    break
            }
        })
    }

    onChangeInput(name: string) {
        this[name] = null
    }
}

export default Component.build(new LoginPage())
